import script from "./UsernameInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./UsernameInput.vue?vue&type=script&setup=true&lang=ts"

import "./UsernameInput.vue?vue&type=style&index=0&id=1bd359f7&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bd359f7"]])

export default __exports__